<template lang="pug">
.financial-detail-table
  .title {{ title }}
  .rows-wrapper 
    .rows
      .row(v-for="item in items")
        span.label {{ item.label }}
        span.value {{ item.value }} 
   
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";
export interface FinancialTableItem {
  label: string;
  value: number;
}

export default defineComponent({
  props: {
    title: {
      type: String,
      requried: true,
    },
    items: {
      type: Object as PropType<FinancialTableItem>,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
</script>

<style scoped lang="scss">
.financial-detail-table {
  border-bottom: $bar-border;
  position: relative;
  height: 100%;

  &:nth-child(odd) {
    .rows-wrapper {
      &:before {
        background-color: $primary-color-light;
      }
    }
  }

  .title {
    margin-bottom: 1rem;
    font-size: 1.15rem;
    font-weight: 500;
  }

  .rows-wrapper {
    background-color: white;
    position: relative;
    &:before {
      content: "";
      width: 100%;
      height: 0.25rem;
      background-color: $primary-color;
      position: absolute;
      top: 0;
    }

    .rows {
      padding: 2rem 1.5rem 1rem 1.5rem;

      .row {
        display: flex;
        justify-content: space-between;
        padding: 0.75rem 0.5rem 0.75rem 0;

        &:not(:last-child) {
          border-bottom: $bar-border;
        }

        .label {
          font-size: 1rem;
        }

        .value {
          font-size: 1.1rem;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
